module.exports = new __parcel__URL__("get-design-updates.688f91ed.png").toString();